module.exports = __webpack_public_path__ + "static/img/signOkicon.fe950c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/signOkicon.png
// module id = Y/ry
// module chunks = 1